<template>
  <div class="m">
    <NavBar
      v-if="titleStatus"
      title="上门范围"
      left-arrow
      fixed
      placeholder
      @click-left="goBack"
      :border="false"
    />
    <GoBack :type="1" />
    <div class="banner">
      <img
        src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/201912/03/105303361.png"
        alt="免费上门取件支持城市"
      />
    </div>
    <span style="font-size: 16px">
      <strong>
        北京市、天津市、上海市、重庆市
        <br />
      </strong>
    </span>
    <br />
    <strong>
      <span style="font-size: 16px">安徽省</span>
    </strong>
    <br />合肥市、芜湖市、蚌埠市、淮南市、马鞍山市、淮北市、铜陵市、安庆市、黄山市、滁州市、阜阳市、宿州市、六安市、亳州市、池州市、宣城市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>浙江省</strong>
    </span>
    <br />杭州市、宁波市、金华市、温州市、衢州市、绍兴市、台州市、湖州市、舟山市、丽水市、嘉兴市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>江苏省</strong>
    </span>
    <br />南京市、无锡市、
    徐州市、常州市、苏州市、南通市、连云港市、淮安市、盐城市、扬州市、镇江市、泰州市、宿迁市
    <br />
    <br />
    <strong>
      <span style="font-size: 16px">广东省</span>
    </strong>
    <br />广州市、韶关市、深圳市、珠海市、汕头市、佛山市、江门市、湛江市、茂名市、肇庆市、惠州市、梅州市、汕尾市、河源市、阳江市、清远市、东莞市、中山市、潮州市、揭阳市、云浮市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>福建省</strong>
    </span>
    <br />福州市、厦门市、莆田市、三明市、泉州市、漳州市、南平市、龙岩市、宁德市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>河北省</strong>
    </span>
    <br />石家庄市、唐山市、秦皇岛市、邯郸市、邢台市、保定市、张家口市、承德市、沧州市、廊坊市、衡水市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>山东省</strong>
    </span>
    <br />济南市、青岛市、淄博市、枣庄市、东营市、烟台市、潍坊市、济宁市、泰安市、威海市、日照市、莱芜市、临沂市、德州市、聊城市、滨州市、菏泽市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>
        江西省
        <br />
      </strong> </span
    >南昌市、九江市、上饶市、宜春市、抚州市、吉安市、赣州市、景德镇市、萍乡市、新余市、鹰潭市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>辽宁省</strong>
    </span>
    <br />沈阳市、大连市、鞍山市、抚顺市、本溪市、丹东市、锦州市、营口市、阜新市、辽阳市、盘锦市、铁岭市、朝阳市、葫芦岛市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>吉林省</strong>
    </span>
    <br />长春市、吉林市、四平市、辽源市、通化市、白山市、松原市、白城市、延边朝鲜族自治州
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>黑龙江省</strong>
    </span>
    <br />哈尔滨市、齐齐哈尔市、鸡西市、鹤岗市、双鸭山市、大庆市、伊春市、佳木斯市、七台河市、牡丹江市、黑河市、绥化市、大兴安岭地区
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>四川省</strong>
    </span>
    <br />成都市、自贡市、攀枝花市、泸州市、德阳市、绵阳市、广元市、遂宁市、内江市、乐山市、南充市、眉山市、宜宾市、广安市、达州市、雅安市、巴中市、资阳市、阿坝藏族羌族自治州、凉山彝族自治州、甘孜藏族自治州
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>湖北省</strong>
    </span>
    <br />武汉市、黄石市、十堰市、宜昌市、襄阳市、鄂州市、荆门市、孝感市、荆州市、黄冈市、咸宁市、随州市、仙桃市、潜江市、天门市、神农架林区、恩施土家族苗族自治州
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>河南省</strong>
    </span>
    <br />郑州市、开封市、洛阳市、平顶山市、安阳市、鹤壁市、新乡市、焦作市、济源市、濮阳市、许昌市、漯河市、三门峡市、南阳市、商丘市、信阳市、周口市、驻马店市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>湖南省</strong>
    </span>
    <br />长沙市、株洲市、湘潭市、衡阳市、邵阳市、岳阳市、常德市、张家界市、益阳市、郴州市、永州市、怀化市、娄底市、湘西土家族苗族自治州
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>广西壮族自治区</strong>
    </span>
    <br />南宁市、柳州市、桂林市、梧州市、北海市、防城港市、钦州市、贵港市、玉林市、百色市、贺州市、河池市、来宾市、崇左市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>云南省</strong>
    </span>
    <br />昆明市、保山市、丽江市、临沧市、普洱市、曲靖市、玉溪市、昭通市、西双版纳傣族自治州、大理市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>贵州省</strong>
    </span>
    <br />贵阳市、六盘水市、遵义市、安顺市、铜仁市、毕节市、黔南布依族苗族自治州
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>山西省</strong>
    </span>
    <br />太原市、大同市、阳泉市、长治市、晋城市、朔州市、晋中市、运城市、忻州市、临汾市、吕梁市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>陕西省</strong>
    </span>
    <br />西安市、 宝鸡市、咸阳市、铜川市、渭南市、延安市、
    榆林市、汉中市、安康市、商洛市
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>甘肃省</strong>
    </span>
    <br />兰州市、嘉峪关市、金昌市、白银市、天水市、武威市、张掖市、酒泉市、平凉市、庆阳市、定西市、陇南市、临夏回族自治州、甘南藏族自治州
    <br />
    <br />
    <span style="font-size: 16px">
      <strong>海南省</strong>
    </span>
    <br />海口市、三亚市、文昌市、三沙市、乐东黎族自治县、琼海市、定安县、万宁市、保亭黎族苗族自治县、儋州市、澄迈市、屯昌市、陵水黎族自治县、东方市、五指山市、白沙黎族自治县、昌江黎族自治县、临高县、琼中黎族苗族自治县
    <br />
    <br />
    <strong>
      <span style="font-size: 16px">
        内蒙古自治区
        <br />
      </span> </strong
    >鄂尔多斯市、包头市、呼和浩特市、阿拉善盟、锡林郭勒盟、兴安盟、乌兰察布市、巴彦淖尔市、呼伦贝尔市、通辽市、赤峰市、乌海市
    <br />
    <br />
    <strong>
      <span style="font-size: 16px">
        宁夏回族自治区
        <br />
      </span> </strong
    >银川市、石嘴山市、吴忠市、固原市、中卫市
    <br />
    <br type="_moz" />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import routers from "@/hooks/routers";
import { useStore } from "vuex";
import GoBack from "../components/GoBack/GoBack.vue";
import { NavBar } from "vant";

export default defineComponent({
  components: { NavBar, GoBack },
  setup() {
    const { goBack } = routers();
    const store = useStore();
    const titleStatus = store.state.titleStatus;
    return { goBack, titleStatus };
  },
});
</script>

<style lang="scss" scoped>
.m {
  width: 100%;
  .banner {
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
